// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_1nup8JKKiT","audioWave":"_2-h4TIj4wK","cursor":"_7VStYMU-rs"};